// Toggle mobile menu open/close on click
$('.menu-toggle-mobile').click(function(e) {
  $('.menu-mobile-wrapper').toggleClass('menu-open')
})

// Toggle desktop menu open/close on click
$('.menu-toggle').click(function(e) {
  $('.menu-wrapper').toggleClass('menu-open')
})

$(document).ready(function() {
  var lastScrollTop = 0
  var navbarOffset = 78

  // Adjust the top position of the navbar based on whether it is stuck or not
  function adjustNavbar() {
    if ($('.event-sticky-bar').hasClass('is-stuck')) {
      $('.menu-wrapper').css('top', navbarOffset + 'px')
    } else {
      $('.menu-wrapper').css('top', '0px')
    }
  }

  $(window).scroll(function(event) {
    var st = $(this).scrollTop()

    if (st > lastScrollTop && st > 30) {
      // User is scrolling down
      // Add class to change navbar background
      $('.menu').addClass('menu-active-scroll')
      $('.menu-mobile-wrapper').addClass('menu-active-scroll')
      // Close any open menus
      $('.menu-wrapper').removeClass('menu-open')
      // Unlock body scroll
      $('body').removeClass('scroll-locked')
    } else {
      // User is scrolling up
      // Add class to change navbar backgorund
      $('.menu').addClass('menu-active-scroll')
      $('.menu-mobile-wrapper').addClass('menu-active-scroll')
      if (st <= 30) {
        // User is at the top of the page
        // Remove active scroll class when at the top of the page
        $('.menu').removeClass('menu-active-scroll')
        $('.menu-mobile-wrapper').removeClass('menu-active-scroll')
      }
    }
    lastScrollTop = st

    adjustNavbar() // Adjust the navbar position
  })

  // Call adjustNavbar initially in case the page is loaded with a scroll position
  adjustNavbar()
})
